import styled from 'styled-components';
import { withTheme } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconCheckCircle from '@material-ui/icons/CheckCircle';
import IconArrowBack from '@material-ui/icons/ArrowBack';
import IconArrowRight from '@material-ui/icons/KeyboardTab';
import { darken } from '@mui/material/styles';

export const Container = styled.div`
  background-color: ${props => props.theme.palette.background.darkest};
  /* background-color: rgba(0, 0, 0, 0.8); */
  color: ${props => props.theme.palette.text.primary};
  height: 174px;
  border-radius: 0 0 6px 0;
  box-shadow: ${props => props.theme.shadows[6]};
`;

export const ButtonReturn = styled(Button).attrs({
  startIcon: <IconArrowBack />,
  variant: 'contained',
  size: 'large'
})`
  min-width: 180px;
  height: 44px;
  background-color: #fff;
  &&:hover {
    background-color: ${darken('#fff', 0.3)};
  }
`;

export const ButtonNext = styled(Button).attrs({
  endIcon: <IconArrowRight />,
  variant: 'contained',
  size: 'large'
  // dark: true
})`
  display: flex;
  margin-left: 16px;
  min-width: 160px;
  height: 44px;
  background-color: #fff;
  &&:hover {
    background-color: ${darken('#fff', 0.3)};
  }
`;

export const ButtonPrimary = styled(Button).attrs({
  color: 'primary',
  variant: 'contained',
  size: 'large',
  dark: true
})`
  display: flex;
  margin-left: 16px;
  min-width: 140px;
  height: 44px;

`;

export const ButtonSubmit = withTheme(styled(Button).attrs({
  variant: 'contained',
  size: 'large'
})`
  margin-left: 16px;
  background-color: ${props => props.disabled ? '#999 !important' : props.theme.palette.success.dark};
  color: ${props => props.disabled ? '#666 !important' : '#FFF'};
  min-width: 300px;
  height: 44px;
  &&:hover {
    background-color: ${props => props.disabled ? '#999' : darken(props.theme.palette.success.dark, 0.3)};
  }
`);
